import { sendFrontendLog } from '../services/logService';

/**
 * Forma di cio' che viene effettivamente spedito come dettaglio del log.
 *
 * Il parametro resta `any` di proposito: chi chiama passa spesso un errore o
 * una stringa, e sono i metodi qui sotto ad avvolgerli in un oggetto. Il tipo
 * descrive il risultato di quell'avvolgimento, non l'ingresso.
 */
interface LogMeta {
  [key: string]: any;
}

const frontendLogger = {
  error: (message: string, meta?: any) => {
    const logMeta: LogMeta = typeof meta === 'object' && meta !== null ? meta : { error: meta };
    console.error(message, logMeta); // Also log to console for immediate dev feedback
    sendFrontendLog('error', message, logMeta);
  },
  warn: (message: string, meta?: any) => {
    const logMeta: LogMeta = typeof meta === 'object' && meta !== null ? meta : { data: meta };
    console.warn(message, logMeta);
    sendFrontendLog('warn', message, logMeta);
  },
  info: (message: string, meta?: any) => {
    const logMeta: LogMeta = typeof meta === 'object' && meta !== null ? meta : { data: meta };
    if (process.env.NODE_ENV !== 'production') { // Only log info to console in dev
        console.info(message, logMeta);
    }
    sendFrontendLog('info', message, logMeta);
  },
  // Add other levels as needed (debug, verbose, etc.)
};

export default frontendLogger;
